import { getRequest, postRequest, patchRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
import { fetchEventDetails } from "DashboardUserAction";
import _ from "lodash";

import { DASHBOARD_TOTAL_USERS } from "DashboardUserAction";
import { DASHBOARD_TOTAL_SESSIONS } from "DashboardSessionAction";
import { DASHBOARD_TOTAL_NETWORKS } from "DashboardNetworkingAction";
import { DASHBOARD_TOTAL_DEVICES } from "DashboardDeviceAction";

export var DASHBOARD_USERS = "DASHBOARD_USERS";
export var DASHBOARD_DEVICE = "DASHBOARD_DEVICE";
export var DASHBOARD_OUTREACH = "DASHBOARD_OUTREACH";
export var DASHBOARD_NETWORKING = "DASHBOARD_NETWORKING";
export var DASHBOARD_SESSIONS = "DASHBOARD_SESSIONS";
export var DASHBOARD_ATTENDEES = "DASHBOARD_ATTENDEES";
export var DASHBOARD_ATTENADOPRATE = "DASHBOARD_ATTENADOPRATE";
export var DASHBOARD_ATTEDENGARATE = "DASHBOARD_ATTEDENGARATE";
export var DASHBOARD_INTERACTION = "DASHBOARD_INTERACTION";
export var DASHBOARD_MESSAGESS = "DASHBOARD_MESSAGESS";
// export var DASHBOARD_ANALYTICS = 'DASHBOARD_ANALYTICS';
export var DASHBOARD_SELECTED_ITEM = "DASHBOARD_SELECTED_ITEM";
export var DASHBOARD_ITEM_SELECTED = "DASHBOARD_ITEM_SELECTED";
export var DASHBOARD_MOSTSEARCH_KEYWORDS = "DASHBOARD_MOSTSEARCH_KEYWORDS";
export var DASHBOARD_ENGAGEMENT_BARCHART = "DASHBOARD_ENGAGEMENT_BARCHART";
export var DASHBOARD_USERSCOUNT = "DASHBOARD_USERSCOUNT";
export var APPUSER_NOT_LOGIN_USERSCOUNT = "APPUSER_NOT_LOGIN_USERSCOUNT";

export function onDashboardMenuSelected(selectedMenu) {
  return (dispatch) => {
    dispatch({ type: DASHBOARD_ITEM_SELECTED, payload: selectedMenu });
  };
}

export function dispatchAnalyticsData(data) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_TOTAL_DEVICES,
      payload: { response: data.devices.response, count: data.devices.count },
    });
    dispatch({
      type: DASHBOARD_TOTAL_SESSIONS,
      payload: { response: data.sessions.response, count: data.sessions.count },
    });
    dispatch({
      type: DASHBOARD_TOTAL_NETWORKS,
      payload: { response: data.networks.response, count: data.networks.count },
    });
    dispatch({
      type: DASHBOARD_TOTAL_USERS,
      payload: { response: data.users.response, count: data.users.count },
    });
  };
}

// Attendees Engagement (CHART VIEW of how actively the exhibitor feature has been use over the selected date range)
const fetchAttendengagementbBarChart = (session, daterange, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=attendsFeatureEngmntData`;

  return (dispatch) => {
    postRequest(
      url,
      {
        type: "attendsFeatureEngmntData",
        types: "entry",
        screen: "overview",
        eventid: session.eventid,
        fromDate: daterange.from,
        toDate: daterange.to,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        dispatch({
          type: DASHBOARD_ENGAGEMENT_BARCHART,
          payload: { response: data.resource },
        });
        callback({
          error: 0,
          data: "Analytics, Chart view of how actively the Attendees feature has been use over the selected date range !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export function updateEvent(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event/${session.eventid}`;

  values = { ...values };

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        dispatch(fetchEventDetails(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

// Most search keywords (Most search keywords related to session)
const fetchMostSearchKeywordsTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=mostsearchkeys&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Dashboard Most Search keywords Table data (List) Installs..
        dispatch({ type: DASHBOARD_MOSTSEARCH_KEYWORDS, data: data.resource });
        callback({
          error: 0,
          data: "Analytics Dashboard Most Search keywords Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export { fetchMostSearchKeywordsTableData, fetchAttendengagementbBarChart };
